import {
  api_portalOfficeHospitalListing_responseFilter,
  ibow2_proto_PortalOfficeHospitalListingService,
} from '@/init/swagger';

export type GroupedAppealPoints = Record<
  string,
  api_portalOfficeHospitalListing_responseFilter[]
>;

type SubCategoryItem = {
  sub_category_id: number;
  label: string;
};

export const SUB_CATEGORIES: Record<string, SubCategoryItem> = {
  ACCESSIBILITY: { sub_category_id: 1, label: '障がいへの対応' },
  SMOKING: { sub_category_id: 2, label: '分煙' },
  MEDICAL_CARE: { sub_category_id: 3, label: '診療・対応' },
  OTHER: { sub_category_id: 99, label: 'その他' },
};

export const extractMatchingFilters = (
  filters: api_portalOfficeHospitalListing_responseFilter[],
  services: ibow2_proto_PortalOfficeHospitalListingService[] | undefined,
): GroupedAppealPoints => {
  const groupedFilters: GroupedAppealPoints = {};

  Object.keys(SUB_CATEGORIES).forEach((key) => {
    groupedFilters[`${key}`] = [];
  });

  filters.forEach((filter) => {
    const key = `${
      Object.keys(SUB_CATEGORIES).find(
        (k) => SUB_CATEGORIES[k].sub_category_id === filter.sub_category_id,
      ) || 'OTHER'
    }`;
    if (!groupedFilters[key]) {
      groupedFilters[key] = groupedFilters[`SUB_CATEGORIES.OTHER`];
    }
    if (
      services != null &&
      services.some(
        (service) =>
          service.search_filter_id === filter.id &&
          service.category_id === filter.category_id,
      )
    ) {
      groupedFilters[key].push(filter);
    }
  });

  return groupedFilters;
};

export const extractMatchingMedicalCares = (
  filters: api_portalOfficeHospitalListing_responseFilter[],
  services: ibow2_proto_PortalOfficeHospitalListingService[] | undefined,
): string[] => {
  const matchingFilters = filters.filter((filter) =>
    services?.some(
      (service) =>
        service.search_filter_id === filter.id &&
        service.category_id === filter.category_id,
    ),
  );

  return matchingFilters.map((filter) => filter.label || '');
};
